import React from 'react';
import { ScrollableViewport, TimeseriesChartItem } from '@ihsm/ui-shared';
import { MarketDataTable } from '../MarketDataTable';

export interface TableSegmentProps {
  chartData: TimeseriesChartItem[];
}

export const TableSegment: React.FC<TableSegmentProps> = ({ chartData }) => (
  <ScrollableViewport vertical>
    <MarketDataTable chartData={chartData} />
  </ScrollableViewport>
);
